import React, { useMemo, useState, useContext, useEffect } from 'react';
import Box from 'Components/Atoms/Box';
import Typography from 'Components/Atoms/Typography';
import Close from '@material-ui/icons/Close';
import InfoOutlined from '@material-ui/icons/InfoOutlined';
import useRestaurant from 'CustomHooks/useRestaurant';
import './styles.scss';
import { ReservationContext } from 'Contexts/ReservationContext';

export type SiaInfosAlertProps = {
  date: string;
};

const SiaInfosAlert: React.FC<SiaInfosAlertProps> = () => {
  const { siaState } = useRestaurant();
  const [hidden, setHidden] = useState(false);
  const [hiddenMessages, setHiddenMessages] = useState<string[]>(
    JSON.parse(window.sessionStorage.getItem(`sia-info`) || '[]'),
  );
  const { reservations, setcurrentReservation } =
    useContext(ReservationContext);

  const infos = useMemo(
    () =>
      (siaState.data?.infos_for_current_date ?? [])
        .sort((a, b) => b.createdAt - a.createdAt)
        .filter((info) => !hiddenMessages.includes(info.id)),
    [siaState.data?.infos_for_current_date, hiddenMessages],
  );

  useEffect(() => {
    if (infos.length > 0 && hidden) {
      setHidden(false);
    }
  }, [infos.length]);

  const handleCloseMessage = (id: string) => {
    let currentSession = window.sessionStorage.getItem(`sia-info`) || '[]';
    let currentInfos = JSON.parse(currentSession);
    window.sessionStorage.setItem(
      `sia-info`,
      JSON.stringify([...currentInfos, id]),
    );
    setHiddenMessages([...hiddenMessages, id]);
  };

  if (!infos.length) {
    return <></>;
  }

  if (hidden) {
    return (
      <Box className="sia-infos-container closed">
        <div className="close-button-container">
          <button className="close-button" onClick={() => setHidden(false)}>
            Nachrichten von Sia anzeigen ({infos.length})
          </button>
        </div>
      </Box>
    );
  }

  return (
    <Box className="sia-infos-container">
      <div className="close-button-container">
        <button className="close-button" onClick={() => setHidden(true)}>
          Verbergen
        </button>
      </div>

      {infos.map((info) => {
        const createdAt = info.createdAt
          ? new Date(info.createdAt).toLocaleTimeString('de-DE').slice(0, 5)
          : null;
        const reservation = info.reservationId
          ? reservations.find((r) => r.id === info.reservationId)
          : null;
        const callerInfo = info.caller?.name
          ? `${info.caller.name} (${info.caller.phoneNumber})`
          : info.caller?.phoneNumber;

        return (
          <Box key={info.id} className="sia-info-message">
            <Typography
              variant="text-5"
              color="subdued"
              className="sia-info-caller"
              translation={null}
            >
              {callerInfo}
            </Typography>

            <Box className="sia-message-row">
              {/* {!!info.reservationId && (
                <button
                  className="sia-info-button"
                  onClick={() =>
                    setcurrentReservation(info?.reservationId ?? null)
                  }
                  aria-label="Open reservation"
                >
                  <InfoOutlined fontSize="small" />
                </button>
              )} */}

              <Box className="sia-message-bubble-wrap">
                <Box className="sia-message-bubble">
                  <Typography
                    variant="text-3"
                    className="sia-message-text"
                    translation={null}
                    dangerouslySetInnerHTML={{ __html: info.message }}
                  />
                </Box>
                <div className="sia-message-tail">
                  <svg
                    className="sia-message-tail-svg"
                    fill="none"
                    preserveAspectRatio="none"
                    viewBox="0 0 16.5 17"
                  >
                    <path
                      d="M5 10.5C4.49857 13.5086 1.66667 16.3333 0 17C6.4 17 10.5 14.8333 11.5 13.5L16.5 15L16 0H5.5V2V4V4.5C5.5 5.5 5.5 7.5 5 10.5Z"
                      fill="#00B7FF"
                    />
                  </svg>
                </div>
                <button
                  className="close-message-button"
                  onClick={() => handleCloseMessage(info.id)}
                >
                  <Close />
                </button>
              </Box>
            </Box>
            {!!info.reservationId && (
              <button
                className="sia-info-reservation"
                onClick={() => {
                  setcurrentReservation(info.reservationId ?? null);
                }}
              >
                <Typography variant="text-5" translation={null}>
                  Reservierung:{' '}
                  <span className="sia-info-reservation-emphasis">
                    {reservation?.guest?.name ||
                      reservation?.customId ||
                      'Reservierung'}{' '}
                  </span>
                  {reservation && (
                    <>
                      ({reservation.guests} PAX, {reservation.time || '--:--'})
                    </>
                  )}
                  {!reservation && <>({info.reservationId})</>}
                </Typography>
              </button>
            )}

            {!!createdAt && (
              <Typography
                variant="text-5"
                color="subdued"
                className="sia-info-time"
                translation={null}
              >
                {createdAt}
              </Typography>
            )}
          </Box>
        );
      })}
    </Box>
  );
};

export default SiaInfosAlert;
